import React from 'react';
import { PixelRatio, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import { useDimensions } from 'react-native-web-hooks';
import { Action } from '../../shell/Actions/Action';
import Character from '../../shell/Character';
import Game from '../../shell/Game';
import useFontSize from '../../shell/hooks/useFontSize';
import { onGetFiles, onLoad } from '../../shell/utils/appManagementFunctions';
import { isMobile } from '../../shell/utils/platformCheck';
import { useAppSelector } from '../../store/hooks';
import { selectMenu, setMenu, setSettings } from '../../store/slices/menuSlice';
import { store } from '../../store/store';
import { SaveLoad, saveObject, saveObjectMetaData } from './SaveLoad';
import SoundClass from '../../shell/Sound';

interface SaveLoadScreenProps {
    files: Map<string, Map<string, saveObjectMetaData>> | undefined,
    setFiles: (files: Map<string, Map<string, saveObjectMetaData>>) => void;
}

export const SaveLoadScreen: React.FC<SaveLoadScreenProps> = React.memo(({ files, setFiles }) => {

    const { height, width } = useDimensions().window;
    const menuSlice = useAppSelector(selectMenu);

    const styles = StyleSheet.create({
        container: {
            display: "flex",
            flex: 1,

        },
        savesContainer: {
            flex: 1,
            flexWrap: "wrap",
            flexDirection: "row",
            height: "100%",
            alignContent: "center",

        },
        saveSlot: {
            width: "25%",
            aspectRatio: 16 / 9,
            color: "white",
            marginTop: 5,
            zIndex: 1
        },
        pagingContainer: {
            display: "flex",
            flexDirection: "row",
            margin: 20 / PixelRatio.get(),
            alignItems: "center",
            justifyContent: "space-around"

        },
        textWrap: {
            borderWidth: 1,
            borderColor: "white",
            padding: useFontSize(1.5 / PixelRatio.get()),
            justifyContent: "center",
            aspectRatio: 1,
            borderRadius: useFontSize(1 / PixelRatio.get()),

        },
        page: {
            color: "white",
            fontSize: useFontSize(2)
        }

    });
    const onRightArrowPressed = () => {
        store.dispatch(setSettings({ page: typeof menuSlice.settings.page === "string" ? 0 : menuSlice.settings.page! + 1 }));

    };
    const onLeftArrowPressed = () => {
        if (typeof menuSlice.settings.page === "number") {
            if (menuSlice.settings.page) {
                store.dispatch(setSettings({ page: menuSlice.settings.page - 1 }));
            }
        }
        // if (typeof menuSlice.settings.page === "number") {
        //     store.dispatch(setSettings({ page: menuSlice.settings.page ? (Number(menuSlice.settings.page) - 1) : 'A' }));
        // }
    };
    const onPagePressed = (page: number | string) => {
        store.dispatch(setSettings({ page }));
    };
    const onSavePressed = async (save: saveObjectMetaData | undefined) => {
        // getPageFiles();

        if (menuSlice.settings.page == null) { return; }
        // delete save

        const dupFiles = new Map(files!);
        if (!save) {
            const pageSaves = await onGetFiles(menuSlice.settings);
            setFiles(dupFiles.set(menuSlice.settings.page.toString(), pageSaves));
            return;
        }
        let pageSaves = files?.get(save.page.toString()) || new Map().set(save.slot.toString(), save);
        if (isMobile()) {

        } else {
            pageSaves = await onGetFiles(menuSlice.settings);

        }
        const existsSaves = dupFiles?.get(save.page.toString());
        if (existsSaves) {
            existsSaves.set(save.slot.toString(), save);
            dupFiles?.set(save.page.toString(), existsSaves);
        } else {
            const newSave = new Map();
            newSave.set(save.slot.toString(), save);
            dupFiles?.set(save.page.toString(), newSave);
        }
        // console.log("save", save);
        setFiles(dupFiles.set(menuSlice.settings.page.toString(), pageSaves));


    };

    const onLoadPressed = async (index: number) => {

        if (menuSlice.settings.page == null || !files?.get(menuSlice.settings.page?.toString())?.get(index.toString())) { return; }
        const fileMeta = files.get(menuSlice.settings.page?.toString())?.get(index.toString());
        if (!fileMeta) { return; }
        const loadFile = await onLoad({ ...fileMeta, page: menuSlice.settings.page, slot: index, folder: menuSlice.settings.folder });
        if (!loadFile) {
            return;
        }


        const shapedGameObject = Game.loadGame(loadFile?.gameObject.present);
        loadFile.gameObject.present = shapedGameObject;
        const { characters } = loadFile.gameObject.present;
        const { settings } = store.getState().menu;

        // Character.characters.forEach(char => {
        //     if (characters[char.key]) {

        //         characters[char.key].properties = { ...char.properties, ...characters[char.key].properties };
        //     }
        // });

        // Object.keys(characters).forEach(char => {
        //     char = 
        // });
        // const chars = store.getState().gameObject.present.characters;
        // if (chars?.[character.key]) {
        //     data = { ...chars[character.key], ...data };
        // }

        Character.characters.forEach(char => {
            if (!characters[char.key]) {
                characters[char.key] = JSON.parse(JSON.stringify(char));
                loadFile.gameObject.past.forEach(past => {
                    if (!past.characters[char.key]) {

                        past.characters[char.key] = JSON.parse(JSON.stringify(char));
                    }
                });
            }
            else {
                // this is fixing the bug with names changing
                if ((char as any)._name) {
                    (char as any)._name = (loadFile.gameObject.present.characters[char.key] as any)?._name;
                }
            }
        });
        Game.rollback = 0;
        // Game.Action = null;

        const payload: Partial<saveObject> = {
            gameObject: { ...loadFile?.gameObject, present: { ...loadFile?.gameObject.present, index: loadFile?.gameObject.present.index ?? 0 } },
            insta: loadFile?.insta,
            sounds: loadFile?.sounds || { sound: [] }
        };
        store.dispatch(setMenu({ display: false, settings, loading: true }));
        // SoundClass.stopAll();
        store.dispatch({ type: "reset", payload });


        setTimeout(() => {

            const additionalScenes = loadFile.gameObject.past?.slice(-10);

            Action.searchScene({ scene: loadFile?.gameObject.present, promiseData: false, additionalScenes, potentialNode: null }, false);
        });
        // Game.rollback = 1;
        let a = Game.Action;
        // Game.Action?.prev?.func();

    };
    // const [selectedValue, setSelectedValue] = useState("java");
    return (
        <View style={styles.container}>
            {/* <View style={styles.container}>
                <Picker
                    selectedValue={selectedValue}
                    style={{ height: 50, width: 150 }}
                    onValueChange={(itemValue, itemIndex) => setSelectedValue(itemValue)}
                >
                    <Picker.Item label="Java" value="java" />
                    <Picker.Item label="JavaScript" value="js" />
                </Picker>
            </View> */}
            <View style={styles.savesContainer}>
                {menuSlice.settings.page != null ? Array.from(Array(12).keys()).map((saveSlot, i) => (
                    // <View key={i} style={styles.saveSlot}>

                    <SaveLoad key={i} onLoadPressed={(index) => onLoadPressed(index)} onSavePressed={(saveObject) => onSavePressed(saveObject)} file={files?.get(menuSlice.settings.page!.toString())?.get(i.toString())!} index={i}></SaveLoad>
                    // </View>
                    // <View style={styles.saveSlot}><Text style={{color:"white"}}>fdsfsdfsdfsdfsdfsdf</Text></View>

                )) : <></>}

            </View>

            <View style={styles.pagingContainer}>
                <TouchableOpacity onPress={() => onLeftArrowPressed()}>
                    <Icon name={"arrow-left"} size={useFontSize(4)} style={{ color: "white" }} />
                </TouchableOpacity>
                {/* <TouchableOpacity onPress={() => onPagePressed('A')} key={'A'} style={styles.textWrap}>
                    <Text style={styles.page}>A</Text>
                </TouchableOpacity> */}
                {Array.from(Array(height > 400 ? 10 : Math.floor((height * 2 / 100))).keys()).map((page, i) => (
                    <TouchableOpacity onPress={() => onPagePressed(i)} key={i} style={styles.textWrap}>
                        <Text style={styles.page}>{i}</Text>
                    </TouchableOpacity>
                ))}
                <TouchableOpacity onPress={() => onRightArrowPressed()}>
                    <Icon name={"arrow-right"} size={useFontSize(4)} style={{ color: "white" }} />
                </TouchableOpacity>

            </View>
        </View>
    );
});;